import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-shell',
  templateUrl: './main-shell.component.html',
  styleUrls: ['./main-shell.component.css']
})
export class MainShellComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
